module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f629.7d9b0ce9.svg";